<template lang="pug">
  component.overlay-title(v-if="title" :is="tag", v-bind="props")
    span {{ title }}
    font-awesome-icon(v-if="tag != 'div'" :icon="{prefix: 'fa', iconName: 'chevron-right'}")
</template>

<script>
import { get } from '@/helpers';

export default {
  name: 'OverlayImages',
  props: {
    hyperlink: {
      type: Object
    },
    title: {
      type: String
    }
  },
  computed: {
    tag() {
      let tag = 'div';
      if (this.path) tag = 'router-link';
      else if (this.href) tag = 'a';
      return tag;
    },
    props() {
      let props = {};

      switch (this.tag) {
        case 'router-link':
          props.to = this.path;
          props.class = "link";
          break;

        case 'a':
          props.href = this.href;
          props.target = this.target;
          props.class = "link";
          break;
      }
      return props;
    },
    href() {
      let href = false;

      if (this.hyperlink.type !== 'internal' && get(this.hyperlink, 'href')) {
        const link = this.hyperlink.href;
        switch (this.hyperlink.type) {
          case 'external':
            if (!link.startsWith('https://') && !link.startsWith('http://')) href = `https://${link}`;
            else href = link;
            break;

          case 'mailto':
            href = `mailto:${link}`;
            break;

          case 'tel':
            href = `tel:${link}`;
            break;
        }
      }
      return href;
    },
    target() {
      return get(this.hyperlink, 'target') || '_self';
    },
    path() {
      if (this.hyperlink.type === 'internal' && get(this.hyperlink, 'menuItem.path'))
        return this.hyperlink.menuItem.path;
      else return false;
    }
  }
};

</script>

<style lang="sass" nolang="scss" scoped>
@import "~@/assets/sass/variables"
.overlay-title
  @apply transition-all duration-200 ease-linear flex opacity-0 absolute h-12 pl-16 pr-10 items-center text-white text-lg font-bold bg-no-repeat no-underline
  width: calc(100% - 4rem)
  background-color: $color-primary
  background-image: url('~@/assets/images/refugium_icon_small.jpg')
  background-size: 3rem
  bottom: 1rem
  left: 2rem
  &.link
    &:hover
      @apply shadow-xl
      background-color: rgba(142, 175, 54, 0.85)
  .svg-inline--fa
    @apply absolute text-2xl
    right: 1rem
</style>
